import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { mutationDeleteCustomerFieldType } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import ConfirmModal from "module-common/ConfirmModal";

export default graphql(mutationDeleteCustomerFieldType)(
  class DeleteButton extends Component {
    static propTypes = { id: PropTypes.number };
    state = { showModal: false };

    render() {
      return [
        <Icon
          key="trash"
          name="recycle-bin"
          onClick={() => this.setState({ showModal: true })}
        />,
        this.state.showModal && (
          <ConfirmModal
            key="modal"
            text="Do you want to delete this field?"
            onCancel={() => this.setState({ showModal: false })}
            onConfirm={this.onConfirm}
          />
        )
      ];
    }

    onConfirm = () => {
      try {
        this.props.mutate({
          variables: {
            customerFieldTypeInput: {
              id: this.props.id
            }
          },
          refetchQueries: ["getCustomerFieldType"]
        });
        this.setState({ showModal: false });
        ShowNotice("customer-field-template-delete-success");
      } catch (error) {
        ShowNotice("customer-field-template-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/customer-field-panel/DeleteButtonWithMutation.js